import { HOST } from "@wb/ui/analytics/host";
import { state } from "@wb/ui/analytics/state";
import type { Identity } from "@wb/ui/analytics/useIdentity";

export const identity: Identity = (id, _email) => {
  // NOTD: GA does not support email
  const { host } = state;

  if (!host) {
    console.warn("No host found");
    return;
  }

  globalThis.gtag("config", HOST[host].ga, {
    user_id: id,
  });
};
